<template>
  <Page>
    <div class="flex h-full min-h-[20rem] items-center justify-center">
      <div class="flex flex-col items-center gap-7 text-center">

        <!-- Icon with animated indicator -->
        <div class="relative">
          <div class="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 shadow-sm">
            <i class="fa-solid fa-user-check text-2xl text-primary" />
          </div>
          <span class="absolute -right-1.5 -top-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-warning shadow-md">
            <i class="pi pi-arrow-right text-[9px] text-white" />
          </span>
        </div>

        <!-- Text -->
        <div class="space-y-1.5 max-w-xs">
          <h1 class="text-xl font-bold text-primary">Redirecting to Reviews</h1>
          <p class="text-sm text-secondary">
            The pending queue is now part of the unified Reviews page.
          </p>
        </div>

        <!-- Progress bar -->
        <div class="h-1 w-44 overflow-hidden rounded-full bg-primary/10">
          <div class="redirect-progress h-full rounded-full bg-primary" />
        </div>

      </div>
    </div>
  </Page>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Page from '@/shared/components/layouts/Page.vue';

definePage({
  meta: {
    title: 'Load Sheet Pending Reviews',
  },
});

const route = useRoute();
const router = useRouter();

onMounted(() => {
  void router.replace({
    path: '/load-sheet/reviews',
    query: {
      ...route.query,
      tab: 'pending',
    },
  });
});
</script>

<style scoped>
@keyframes redirect-fill {
  from { width: 0%; }
  to   { width: 100%; }
}

.redirect-progress {
  animation: redirect-fill 0.75s ease-out forwards;
}
</style>
